import { render } from "./SmsPaymentHistory.vue?vue&type=template&id=9bb94b9e&scoped=true"
import script from "./SmsPaymentHistory.vue?vue&type=script&lang=js"
export * from "./SmsPaymentHistory.vue?vue&type=script&lang=js"

import "./SmsPaymentHistory.vue?vue&type=style&index=0&id=9bb94b9e&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bb94b9e"]])

export default __exports__